import React from 'react';
import { Link } from 'react-router';
import { Helmet } from '@dr.pogodin/react-helmet';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import Main from '../layouts/Main';

import markdown from '../data/about.md';

const count = markdown.split(/\s+/)
  .map((s) => s.replace(/\W/g, ''))
  .filter((s) => s.length).length;

// Route internal links through react-router; leave mailto/external links alone.
const components = {
  a: ({ href, children }) => (
    href && href.startsWith('/')
      ? <Link to={href}>{children}</Link>
      : <a href={href}>{children}</a>
  ),
};

const About = () => (
  <Main>
    <Helmet title="About" />
    <article className="post" id="about">
      <header>
        <div className="title">
          <h2><Link to="/about">About Me</Link></h2>
          <p>(in about {count} words)</p>
        </div>
      </header>
      {/* about.md contains raw HTML (<br>, mailto anchors), which react-markdown
          strips unless rehype-raw is enabled. This replaces the old
          escapeHtml={false} prop, removed in react-markdown 6. */}
      <ReactMarkdown components={components} rehypePlugins={[rehypeRaw]}>
        {markdown}
      </ReactMarkdown>
    </article>
  </Main>
);

export default About;
